import { ERROR_CODES } from '@/api/utils/dict'
import { dict } from '@/app/utils/dict'
import { AxiosError } from 'axios'
import { ZodError } from 'zod'

export const isApiErrorCode = (e: unknown, code: ERROR_CODES): boolean => {
  if (!(e instanceof AxiosError)) return false

  return e.response?.data?.message === code
}

export const parseError = (e: unknown): string[] => {
  if (e instanceof AxiosError) {
    const data = e.response?.data

    if (data?.error?.name === 'ZodError') {
      try {
        const issues = JSON.parse(data.error.message)
        const issue = issues.at(0)

        if (issue) {
          return [dict[issue.message] || issue.message]
        }
      }
      catch {
        console.error(e)
      }
    }

    if (typeof data?.message === 'string') {
      const dictMessage = dict[data.message] || (dict[ERROR_CODES.unknownError] as string)

      return [dictMessage]
    }
  }

  if (e instanceof ZodError) {
    const issue = e.issues.at(0)

    if (issue) {
      return [dict[issue.message] || issue.message]
    }
  }

  if (typeof e === 'string') {
    const dictMessage = dict[e] || (dict[ERROR_CODES.unknownError] as string)
    return [dictMessage]
  }

  return [dict[ERROR_CODES.unknownError] as string]
}
